import Vue from 'vue';
import toastr from 'toastr';
import { i18n } from '@/plugins/i18n';
import * as actionsTypes from './action-types';
import * as mutationsTypes from './mutation-types';

// Utils
import {
  datesBetweenRange,
  formatDataFromCompany,
  getDataFromChildren,
  neededProperties,
} from '@/utils/shizen-stats-utils';

export default {
  /** Get the current Jira issue comments */
  async [actionsTypes.FETCH_SHIZEN_STATS](store, payload) {
    /** Check if a refresh is needed */
    if (store.state.stats.companies && !payload.forceRefresh) {
      /** If we have more than one company we do not need to refresh because
       * it mean we already have all companies
       */
      // WARNING : Remove in order to secure the problems of stats not loading
      // if (store.state.stats.companies.length > 1) {
      //   return null;
      // }
      const currentCompany = store.state.stats.companies
        .find(company => Number(company.id) === Number(payload.ids.companyId));
        /** If we have more than one team we do not need to refresh because
         * it mean we already have all teams
         */
      if (payload.dataType === 'companies' && currentCompany.teams && currentCompany.teams.length > 1) {
        return null;
      }
      if (currentCompany && payload.dataType === 'teams') {
        const currentTeam = currentCompany.teams.find(team => Number(team.id) === Number(payload.ids.teamId));
        /** If we have more than one user we do not need to refresh because
         * it mean we already have all users
         */
        if (currentTeam.users && currentTeam.users.length > 1) {
          return null;
        }
        if (currentTeam && payload.dataType === 'users') {
          const currentUser = currentTeam.users.find(user => Number(user.id) === Number(payload.ids.userId));
          if (currentUser) {
            return null;
          }
        }
    }
    }
    store.commit(mutationsTypes.GET_SHIZEN_STATS_LOADING, { ...payload, loading: true });
    return Vue.axios({
      method: 'post',
      url: '/server/shizenStats/getGlobalStats.php',
      data: { ...payload },
    })
      .then((response) => {
        let { data } = response;
        if (data instanceof Object) {
          const formattedStats = { companies: [] };
          const { start, end } = payload.range;
          const dates = datesBetweenRange(Vue.moment(start), Vue.moment(end));
          formattedStats.rangeOfDates = dates;
          data = formatDataFromCompany(data, dates);
          data.forEach((company) => {
            formattedStats.nUsers = (formattedStats.nUsers || 0) + Number(company.nUsers);
            formattedStats.sumNActionsCreated = (
              formattedStats.sumNActionsCreated || 0
            ) + Number(company.sumNActionsCreated);

            formattedStats.sumNActionsFinished = (
              formattedStats.sumNActionsFinished || 0
            ) + Number(company.sumNActionsFinished);

            formattedStats.sumNPbCreated = (formattedStats.sumNPbCreated || 0) + Number(company.sumNPbCreated);
            formattedStats.sumNPbFinished = (formattedStats.sumNPbFinished || 0) + Number(company.sumNPbFinished);
            formattedStats.sumAfkTime = (formattedStats.sumAfkTime || 0) + Number(company.sumAfkTime);
            formattedStats.sumOnlineTime = (formattedStats.sumOnlineTime || 0) + Number(company.sumOnlineTime);
            formattedStats.sumNConnection = (formattedStats.sumNConnection || 0) + Number(company.sumNConnection);
            formattedStats.sumActionCreatingTime = (
              formattedStats.sumActionCreatingTime || 0
            ) + Number(company.sumActionCreatingTime);

            formattedStats.sumPbCreatingTime = (
              formattedStats.sumPbCreatingTime || 0
            ) + Number(company.sumPbCreatingTime);

            formattedStats.sumNBugs = (formattedStats.sumNBugs || 0) + Number(company.sumNBugs);
            formattedStats.sumNTasks = (formattedStats.sumNTasks || 0) + Number(company.sumNTasks);
            formattedStats.companies.push(company);
            formattedStats.data = {};
            neededProperties.forEach((prop) => { formattedStats.data[prop] = {}; });
            neededProperties.forEach((prop) => {
              formattedStats.data[prop] = getDataFromChildren(formattedStats.companies, prop);
            });
          });
          formattedStats.isFormatted = true;
          store.commit(mutationsTypes.GET_SHIZEN_STATS, { ...payload, formattedStats });
          store.commit(mutationsTypes.GET_SHIZEN_STATS_LOADING, { ...payload, loading: false });
          store.commit(mutationsTypes.FORMAT_SHIZEN_STATS, { ...payload });
          return data;
        }
        throw response;
      })
      .catch((err) => {
        store.commit(mutationsTypes.GET_SHIZEN_STATS_LOADING, { ...payload, loading: false });
        toastr.error(i18n.t('message.CONNECTION_ERROR'));
        throw err;
      });
  },
};
